import { IAugmentedJQuery, IDirective, IDirectiveFactory, IScope } from "angular";
import { assigneeAvatar } from "@gtmhub/assignees";

const DEFAULT_AVATAR = "/dist/img/avatars/default_avatar.png";

export interface IAvatarScope extends IScope {
  picture: string;
  email: string;
  url: string;
  isActive: boolean;
  isDeleted: boolean;
}

export class Avatar implements IDirective {
  public scope = {
    picture: "@",
    email: "@",
    isActive: "=",
    isDeleted: "=",
  };
  public restrict = "E";
  public transclude = true;
  public template = `<img class="avatar" ng-class="{'deactivated': isActive === false}" lazy-src="{{ url }}" alt="Avatar" data-test-id="user-avatar-img"/>`;

  public link(scope: IAvatarScope, element: IAugmentedJQuery): void {
    scope.$watch("picture", () => {
      const avatar = assigneeAvatar(scope);
      const imgElement = element.children("img.avatar");

      scope.url = avatar && "picture" in avatar ? avatar.picture : null;

      imgElement.on("error", () => {
        //This is used instead "scope.url" to prevent some delay with load default img and shows broken img into the browse
        const url = webappConfig().cdnStorage.url;

        imgElement[0].setAttribute("src", `${url}${DEFAULT_AVATAR}`);
      });
    });
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new Avatar();
    directive.$inject = [];
    return directive;
  }
}
